
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services";
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { Model } from "@/utils/models/model";
import Vue from "vue";
import AppColumnSelect from "@/components/models/ColumnSelect.vue";
import { Image } from "../../utils/label-layout/image";

export default Vue.extend({
	data(){
		return {
			image: new Image(),
		};
	},
	props: {
		value: {
			type: Object as ()=>Image,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		browse():Browse | null{
			return BrowseService.getBrowseWithoutViewSettings(this.layout.BrowseID);
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.image = new Image(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", new Image(this.image.getJSON()));
			this.close();
		},
	},
	components: {
		AppColumnSelect
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
